var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSunIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dark-Mode-Toggle",
    transform: "translate(-4 -4)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dark-mode-light-mode-toggle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(4 4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.935 2.887a4.052 4.052 0 00-4.047 4.048 4.052 4.052 0 004.047 4.047 4.052 4.052 0 004.048-4.047 4.053 4.053 0 00-4.048-4.048m0 8.673A4.63 4.63 0 012.31 6.935a4.63 4.63 0 014.625-4.626 4.63 4.63 0 014.626 4.626 4.63 4.63 0 01-4.626 4.625",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.358 -.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.577 1.736a.29.29 0 01-.29-.29V.292a.29.29 0 01.579 0v1.156a.29.29 0 01-.29.289",
    id: "Fill-3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.444 7.223H.29a.29.29 0 010-.578h1.155a.29.29 0 010 .578",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.584 7.223h-1.156a.29.29 0 010-.578h1.156a.29.29 0 010 .578",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.267 2.557a.29.29 0 01-.204-.084l-.817-.818a.29.29 0 01.409-.408l.817.816a.29.29 0 01-.205.494",
    id: "Fill-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.602 2.557a.29.29 0 01-.205-.494l.819-.816a.29.29 0 01.408.408l-.817.818a.29.29 0 01-.205.084",
    id: "Fill-12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.935 13.87a.29.29 0 01-.29-.29v-1.155a.29.29 0 01.579 0v1.156a.29.29 0 01-.29.289",
    id: "Fill-14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45 12.708a.29.29 0 01-.205-.494l.818-.817a.29.29 0 01.409.409l-.817.818a.29.29 0 01-.204.084",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.42 12.708a.29.29 0 01-.205-.084l-.817-.818a.29.29 0 01.408-.409l.818.817a.29.29 0 01-.204.494",
    id: "Fill-18"
  })))))));
}

SvgSunIcon.displayName = 'SunIcon';
export default SvgSunIcon;